import UserProfileStore from './user-profile.store';

export const ProfileStores = {
  profile: UserProfileStore,
};
